import React, { Component } from "react";
import CircleItem from "../circleItem";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { FormattedMessage, injectIntl } from 'react-intl';
import SessionManager from "../../utils/authHandling/session-manager";
import {
  DEFAULT_LANGUAGE,
  uploadLink,
  ROLE_STR_ADMIN,
  ROLE_STR_VIDEO_ARTIST,
} from "../../config";
import Dropzone from "react-dropzone-uploader";

class FileDropzone extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chosenMedia: "",
      uploadType: "",
      roles:
        SessionManager.getSession() !== null
          ? SessionManager.getSessionDetails().Roles
          : [],
      files: [],
      audioHeaders: [],
      videoHeaders: [],
      submitDisabled: true,
      hasShownAlert: false,
    };
    this.chooseMedia = this.chooseMedia.bind(this);
    this.closeDropzone = this.closeDropzone.bind(this);
    // this.getRules = this.getRules.bind(this);
    this.getUploadParams = this.getUploadParams.bind(this);
    this.handleChangeStatus = this.handleChangeStatus.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.validateFiles = this.validateFiles.bind(this);

  }

  //function to verify if user can upload videos
  IsRoleAllowedToUploadVideos = (RoleList) => {
    var allowedRoles = [ROLE_STR_ADMIN, ROLE_STR_VIDEO_ARTIST];
    return allowedRoles.some((role) => RoleList.includes(role));
  };

  chooseMedia(value, type) {
  if (this.state.uploadType === type) {
    this.setState({ 
      chosenMedia: value, 
      showDropzone: true,
      hasShownAlert: false
    });
    return;
  }

  // Reset headers when changing upload type (audio, video, image)
  this.setState({ 
    chosenMedia: value, 
    showDropzone: true, 
    uploadType: type, 
    audioHeaders: [], 
    videoHeaders: [],
    submitDisabled: true
  });
}

  closeDropzone() {
    this.setState({ showDropzone: false });
  }

  getUploadParams = (headers) => {
    //In order to get the response URL: headers.xhr.response NOTE: this object is available when the call ends, it is async
    this.setState({ dropzoneResponseObject: headers });
    if (this.state.uploadType === "audio") {
      let newState = this.state.audioHeaders;
      newState.push(headers);
      this.setState({ audioHeaders: newState });
      //if there are two files then we activate the submit
      const findAudioMp3 = newState.find(item => item.meta.type === 'audio/mp3' || item.meta.type === 'audio/mpeg');
      if (findAudioMp3) {
        this.setState({ submitDisabled: false });
      }
    }
    if (this.state.uploadType === "video") {
      let newState = this.state.videoHeaders;
      newState.push(headers);
      this.setState({ videoHeaders: newState });
      //if there are two files then we activate the submit
      const findAudioMp4 = newState.find(item => item.meta.type === 'video/mp4');
      if (findAudioMp4) {
        this.setState({ submitDisabled: false });
      }
    }
    return {
      url:
        uploadLink +
        "subject=" +
        this.props.subject +
        "&level=" +
        this.props.grade +
        "&uploadType=" +
        this.state.uploadType +
        "&langCode=" +
        this.props.language,
      headers: {
        Token: SessionManager.getSession(),
        "Accept-Language":
          localStorage.getItem("i18nextLng") == null
            ? DEFAULT_LANGUAGE
            : localStorage.getItem("i18nextLng"),
      },
    };
  };

  //here we can get image size and set a cancellation if the file does not follow the rules.
  handleChangeStatus = (fileWithMeta, status) => {
    const { intl } = this.props;
    const {uploadType, hasShownAlert} = this.state;
    // Validate if the audio format is mp3
    if (!hasShownAlert && fileWithMeta.meta.type !== "audio/mpeg" && fileWithMeta.meta.type  !== "audio/mp3" && uploadType === 'audio') {
      alert(intl.formatMessage({id: "audio-type-error"}));
      this.setState({ hasShownAlert: true });
      return false; 
    }
    // Validate if the video format is mp4
    if (!hasShownAlert && fileWithMeta.meta.type !== "video/mp4" && uploadType === 'video') {
      alert(intl.formatMessage({id: "video-type-error"}));
      this.setState({ hasShownAlert: true });
      return false; 
    }
    
    if (status === "done" && this.state.uploadType === 'image') {
      this.setState({ submitDisabled: false });
    }
    if (status === "error_upload") {
      fileWithMeta.remove();
    }
    if (this.state.uploadType === 'image') {
      if (fileWithMeta.meta.height > this.props.fileRules[0].MaxHeight) {
        fileWithMeta.cancel();
      }
    }
  };

  handleSubmit = (files, allFiles) => {
    let response = JSON.parse(
      this.state.dropzoneResponseObject.xhr.responseText
    );
    switch (this.state.chosenMedia) {
      case "image/png, image/jpg, image/jpeg":
        if (this.state.removeFile) {
          allFiles.forEach((f) => {
            f.remove();
          });
          alert("File id too large");
        } else {
          this.props.onChange(
            this.props.parentStateKey,
            this.props.content +
              "<img " +
              (this.props.isQuiz ? 'style="max-width: 150px;"' : "") +
              'src="' +
              response.Messages[0] +
              '" />'
          );
        }
        break;
      case "audio/mp3, audio/mpeg":
        let audioInputString = "";
        this.state.audioHeaders.forEach((item) => {
          let singleResponse = JSON.parse(item.xhr.responseText);
          audioInputString =
            audioInputString +
            '<source src="' +
            singleResponse.Messages[0] +
            '" type="audio/' +
            singleResponse.Messages[1].substr(
              singleResponse.Messages[1].length - 3
            ) +
            '">';
        });
        this.props.onChange(
          this.props.parentStateKey,
          this.props.content +
            "<p><audio controls>" +
            audioInputString +
            "Your browser does not support the audio element.</audio>"
        );
        this.setState({ audioHeaders: [] });
        break;
      case "video/mp4":
        let videoInputString = "";
        this.state.videoHeaders.forEach((item) => {
          let singleResponse = JSON.parse(item.xhr.responseText);
          videoInputString =
            videoInputString +
            '<source src="' +
            singleResponse.Messages[0] +
            '" type="video/' +
            (singleResponse.Messages[1].substr(
              singleResponse.Messages[1].length - 3
            ) === "ogv"
              ? "ogg"
              : singleResponse.Messages[1].substr(
                  singleResponse.Messages[1].length - 3
                )) +
            '">';
        });
        this.props.onChange(
          this.props.parentStateKey,
          this.props.content +
            '<p><video controls style="width:80%;height:auto;margin-left:10%;">' +
            videoInputString +
            "Your browser does not support the video element.</video>"
        );
        this.setState({ videoHeaders: [] });
        break;
      default:
        //default string to remove warning. this case should never be reached anyway.
        break;
    }
    allFiles.forEach((f) => f.remove());
  };

  validateFiles(droppedFile) {
    if (droppedFile.meta.type === 'audio/mpeg') {
      droppedFile.meta.type = 'audio/mp3';
    }
    let appliedRules = {};
    let messages = [];
    this.props.fileRules.forEach((item) => {
      let typeString = item.Classification + "/" + item.Format;
      if (typeString === droppedFile.meta.type) {
        appliedRules = item;
      }
    });
    if (appliedRules.Classification === "image") {
      if (droppedFile.meta.height > appliedRules.MaxHeight) {        
        messages.push(this.props.intl.formatMessage({id: "va-max-height-image"}, { size: this.bytesToSize(appliedRules.MaxHeight)}));
      }
      if (droppedFile.meta.width > appliedRules.MaxWidth) {
        messages.push(this.props.intl.formatMessage({id: "va-max-width-image"}, { size: this.bytesToSize(appliedRules.MaxWidth)}));
      }
      if (droppedFile.meta.size > appliedRules.MaxSize) {
        messages.push(this.props.intl.formatMessage({id: "va-max-size-image"}, { size: this.bytesToSize(appliedRules.MaxSize)}));
      }
    }
    if (appliedRules.Classification === "audio") {
      if (droppedFile.meta.size > appliedRules.MaxSize) {
        messages.push(this.props.intl.formatMessage({id: "va-max-size-audio"}, { size: this.bytesToSize(appliedRules.MaxSize)}));
      }
    }
    if (appliedRules.Classification === "video") {
      if (droppedFile.meta.size > appliedRules.MaxSize) {
        messages.push(this.props.intl.formatMessage({id: "va-max-size-video"}, { size: this.bytesToSize(appliedRules.MaxSize)}));
      }
    }
    if (messages.length > 0) {
      droppedFile.remove();
      alert(messages);
    }
  }

  bytesToSize = (bytes) => {
    let sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes == 0) return '0 Byte';
    let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.uploadType !== this.state.uploadType) {
      this.setState({ hasShownAlert: false });
    }
}

  render() {
    const roles = this.state.roles,
      baseStyle = {
        flex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "20px",
        borderWidth: 2,
        borderRadius: 2,
        borderColor: "#eeeeee",
        borderStyle: "dashed",
        backgroundColor: "#fafafa",
        color: "#bdbdbd",
        outline: "none",
        transition: "border .24s ease-in-out",
      };
    return (
      <div className="card-alt">
        <Container style={{ marginTop: "2rem", marginBottom: "2rem" }}>
          <Row>
            <Col
              className={
                this.state.uploadType === "image"
                  ? "dropzone-type-selected"
                  : ""
              }
              style={{ paddingTop: "1rem", paddingBottom: "0.5rem" }}
              onClick={() =>
                this.chooseMedia("image/png, image/jpg, image/jpeg", "image")
              }
            >
              <CircleItem imgSrc="faImage" size="50px">
                <FormattedMessage id="um-image" />
              </CircleItem>
            </Col>
            <Col
              className={
                this.state.uploadType === "audio"
                  ? "dropzone-type-selected"
                  : ""
              }
              style={{ paddingTop: "1rem", paddingBottom: "0.5rem" }}
              onClick={() => this.chooseMedia("audio/mp3, audio/mpeg", "audio")}
            >
              <CircleItem imgSrc="audio" size="50px">
                <FormattedMessage id="um-audio" />
              </CircleItem>
            </Col>
            {this.IsRoleAllowedToUploadVideos(roles) ? (
              <Col
                className={
                  this.state.uploadType === "video"
                    ? "dropzone-type-selected"
                    : ""
                }
                style={{ paddingTop: "1rem", paddingBottom: "0.5rem" }}
                onClick={() =>
                  this.chooseMedia("video/mp4", "video")
                }
              >
                <CircleItem imgSrc="video" size="50px">
                  <FormattedMessage id="um-video" />
                </CircleItem>
              </Col>
            ) : null}
          </Row>
        </Container>
        {this.state.showDropzone ? (
          <Dropzone
          //re render component when the upload type changes
            key={`Dropzone-${this.state.uploadType}`} 
            accept={this.state.chosenMedia}
            validate={this.validateFiles}
            timeout={180000}
            submitButtonDisabled={this.state.submitDisabled}
            style={baseStyle}
            getUploadParams={this.getUploadParams}
            onChangeStatus={this.handleChangeStatus}
            onSubmit={this.handleSubmit}
            styles={{ dropzone: baseStyle }}
            inputContent={
              <FormattedMessage id={"u-" + this.state.uploadType} />
            }
          />
        ) : null}
      </div>
    );
  }
}

export default injectIntl(FileDropzone);
